import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsVatNumberStyles {
    titleText?: TypographyPresentationProps;
    vatNumberText?: TypographyPresentationProps;
    wrapper?: GridItemProps;
}

export const vatNumberStyles: OrderDetailsVatNumberStyles = {
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = vatNumberStyles;

const OrderDetailsVatNumber = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.customerVatNumber) {
        return null;
    }
    return (
    <GridItem {...styles.wrapper}>    
     <Typography {...styles.vatNumberText}><strong> {translate("Secondary PO Number")}</strong>: {order.customerVatNumber}</Typography>
   </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsVatNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
